var map = {
	"./a.jpg": 2217,
	"./a.png": 657,
	"./about-img.jpg": 5134,
	"./b.png": 5459,
	"./best-seller.png": 5361,
	"./blog-1.jpg": 7408,
	"./blog-2.jpg": 6014,
	"./blog-3.jpg": 4578,
	"./burrito-img.png": 3038,
	"./burrito/burrito-1.jpg": 3670,
	"./burrito/burrito-1.png": 384,
	"./burrito/burrito-2.jpg": 891,
	"./burrito/burrito-2.png": 6916,
	"./burrito/burrito-3.jpg": 1552,
	"./burrito/burrito-3.png": 6504,
	"./burrito/burrito-4.jpg": 3841,
	"./burrito/burrito-4.png": 2203,
	"./burrito/burrito-5.jpg": 367,
	"./burrito/burrito-5.png": 934,
	"./burrito/burrito-6.jpg": 3471,
	"./burrito/burrito-6.png": 5574,
	"./chef.png": 4095,
	"./coca-img.png": 1345,
	"./dessert-img.png": 755,
	"./dessert/dessert-1.jpg": 3966,
	"./dessert/dessert-1.png": 1995,
	"./dessert/dessert-2.jpg": 2423,
	"./dessert/dessert-2.png": 1729,
	"./dessert/dessert-3.jpg": 6021,
	"./dessert/dessert-3.png": 8975,
	"./dessert/dessert-4.jpg": 8473,
	"./dessert/dessert-4.png": 1421,
	"./dessert/dessert-5.jpg": 9657,
	"./dessert/dessert-5.png": 9685,
	"./dessert/dessert-6.jpg": 1266,
	"./dessert/dessert-6.png": 3827,
	"./dessert/dessert-7.jpg": 2899,
	"./dessert/dessert-7.png": 2718,
	"./dis-1.jpg": 2952,
	"./dis-2.jpg": 9094,
	"./dis-2.png": 2665,
	"./dis-3.jpg": 5208,
	"./discount.png": 8109,
	"./download.png": 2177,
	"./drink/drink-1.jpg": 1608,
	"./drink/drink-1.png": 8884,
	"./drink/drink-2.jpg": 3898,
	"./drink/drink-2.png": 5995,
	"./drink/drink-3.jpg": 1932,
	"./drink/drink-3.png": 2827,
	"./drink/drink-4.jpg": 3976,
	"./drink/drink-4.png": 5171,
	"./drink/drink-5.jpg": 7242,
	"./drink/drink-5.png": 1858,
	"./drink/drink-6.jpg": 6373,
	"./drink/drink-6.png": 4619,
	"./drink/taco-chef.jpg": 4121,
	"./home.png": 2402,
	"./icon-1.png": 672,
	"./icon-2.png": 9102,
	"./icon-3.png": 6713,
	"./menu.png": 3325,
	"./nachos-img.png": 5331,
	"./nachos/nachos-1.jpg": 8738,
	"./nachos/nachos-1.png": 3320,
	"./nachos/nachos-2.jpg": 319,
	"./nachos/nachos-2.png": 9122,
	"./nachos/nachos-3.jpg": 8007,
	"./nachos/nachos-3.png": 5816,
	"./nachos/nachos-4.jpg": 2273,
	"./nachos/nachos-4.png": 1505,
	"./nachos/nachos-5.jpg": 3892,
	"./nachos/nachos-5.png": 3433,
	"./nachos/salsa-1.jpg": 5881,
	"./nachos/salsa-1.png": 3704,
	"./nachos/salsa-2.jpg": 3452,
	"./nachos/salsa-2.png": 5540,
	"./nachos/salsa-3.jpg": 9864,
	"./nachos/salsa-3.png": 8732,
	"./nachos/salsa-4.jpg": 6714,
	"./nachos/salsa-4.png": 7936,
	"./nachos/salsa-5.jpg": 5072,
	"./nachos/salsa-5.png": 5908,
	"./no-orders.png": 5214,
	"./notfound.jpg": 5894,
	"./notfound.png": 2333,
	"./row-banner.png": 6082,
	"./salad-img.png": 9287,
	"./serv-1.png": 4096,
	"./serv-2.png": 8218,
	"./serv-3.png": 2891,
	"./serv-4.png": 3425,
	"./shopping-cart.png": 1306,
	"./side/side-1.jpg": 2179,
	"./side/side-1.png": 1426,
	"./side/side-2.jpg": 8190,
	"./side/side-2.png": 2138,
	"./side/side-3.jpg": 9516,
	"./side/side-3.png": 9493,
	"./side/side-4.jpg": 7850,
	"./side/side-4.png": 8176,
	"./side/side-5.jpg": 8462,
	"./side/side-5.png": 1980,
	"./taco-background.png": 2913,
	"./taco-chef.png": 101,
	"./taco-chefcartoon.jpg": 5419,
	"./taco-chefcartoon.png": 7033,
	"./taco-home-img.png": 9419,
	"./taco-img.png": 1690,
	"./taco-logo.png": 2579,
	"./taco-truck.png": 2245,
	"./taco/taco-1.jpg": 663,
	"./taco/taco-1.png": 1358,
	"./taco/taco-2.jpg": 474,
	"./taco/taco-2.png": 6178,
	"./taco/taco-3.png": 6345,
	"./taco/taco-4.jpg": 8043,
	"./taco/taco-4.png": 2986,
	"./taco/taco-5.png": 3103,
	"./taco/taco-6.png": 2978,
	"./taco/taco-7.png": 9889,
	"./taco/taco-8.png": 1146,
	"./user.png": 4353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;